module.exports = __webpack_public_path__ + "img/1 (6).c0a34ea7.jpg";